import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { SCDocumentacionAceptadaModalCondicionado } from "./SCDocumentacionAceptadaModalCondicionado";
import ArticleIcon from "@mui/icons-material/Article";
// Icono para "Documento no requerido en esta solicitud" (estatus "X").
import BlockIcon from "@mui/icons-material/Block";


export const AnalizarDocumentacionAprobadaCondicionado = ({
    folio,
    setLoader,
    loader,
    idproceso = 31,
    upload,
}) => {
    function capitalizar(cadena) {
        return cadena.charAt(0).toUpperCase() + cadena.slice(1).toLowerCase();
    }
    const [doctoselect, setDoctoSelect] = useState({
        iddocumento: "",
        documento: "",
    });

    const [data, setData] = useState({
        estado: {},
        detalle: [],
    });
    const [documentoselect, setDocumentoSelect] = useState({});

    useEffect(() => {
        onObtenerAnalisisDocumentacion();
    }, []);
    const onObtenerAnalisisDocumentacion = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ACDocumentacion/AnalizarDocumentosAceptadosCondicionado?folio=${folio}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    detalle: result.detalle,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const OnGetIcon = ({ icon }) => {
        switch (icon) {
            case "wait":
                return <PendingIcon className="wait" />;
            case "success":
                return <CheckCircleIcon className="success" />;
            case "warning":
                return <WarningIcon className="warning" />;
            case "error":
                return <ErrorIcon className="error" />;
            default:
                <></>;
        }
    };

    const onImprimirArchivo = (iddocumento) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
                    iddocumento
                )}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.comentarios;
                const downloadLink = document.createElement("a");
                const fileName = `${result.documento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const openModal = (documento, iddocumento) => {
        var modal = document.getElementById("modal-documentos");
        modal.style.display = "block";
        setDocumentoSelect({
            documento,
            iddocumento,
        });
    };

    //Imprime el pedido Generado cuando aun no se a cargado las firmas
    const onImprimirPedidoMaquinaria = (item) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };
    const onImprimirPagare = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`Pagares/ImprimirPagare?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                if (result.length > 0) {
                    result.forEach((documento, index) => {
                        const linkSource = `data:application/pdf;base64, ${documento.documento}`;
                        const downloadLink = document.createElement("a");
                        const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension
                            }`; // Añade el número de documento al nombre del archivo
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    });
                } else {
                    Swal.fire(
                        "Clientes",
                        "No se encontraron documentos para descargar",
                        "info"
                    );
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onModalComentarios = (valor, iddocumento) => {
        Swal.fire({
            title: "Agregar Comentario",
            input: "textarea",
            inputPlaceholder: "Escribe un comentario...",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Enviar",
        }).then((result) => {
            if (result.isConfirmed) {
                // Aquí puedes manejar lo que sucede cuando se confirma el modal.
                // console.log('Comentario enviado:', result.value, valor);
                const comentarios = result.value === undefined || result.value === null || result.value === ''
                    ? 'Documento Aprobado' : result.value;
                onGuardar(comentarios, valor, iddocumento);
            }
        });
    };

    const onGuardar = (comentarios, estatus, iddocumento) => {
        setLoader({ ...loader, mostrar: true });

        const post = {
            folio: folio,
            estatus,
            comentarios,
            iddocumento,
        };

        request
            .post(`ACTimelineComentariosTask/EnviarComentarioDocumentacionAceptadaCondicionado`, post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    ...data,
                    detalle: result.documentos,
                });
                // if (result.mdlSolicitud[0].idempleado !== 0) {
                //     commentNotification(result.mdlSolicitud);
                // }
                if (result.completado.completado === 1) {
                    upload(folio)
                }
                // const fecha = result.fecha_compromiso.split('T')[0];
                // setCompromiso(fecha);
                // onObtenerAnalisisDocumentacion();
                // upload();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    return (
        <div className="analisis-solicitud-credito-proceso-condicionado-cargar-doc">
            <SCDocumentacionAceptadaModalCondicionado
                folio={folio}
                documento={documentoselect.documento}
                iddocumento={documentoselect.iddocumento}
                loader={loader}
                setLoader={setLoader}
                setdocumento={setDocumentoSelect}
                setdocumentos={onObtenerAnalisisDocumentacion}
                cargar={true}
                onObtenerAnalisisDocumentacion={onObtenerAnalisisDocumentacion}
            />
            <div className="analisis-solicitud-credito-proceso-condicionado-analizar-doc-container scroll-4">
                {data.detalle === undefined ||
                    data.detalle === null ||
                    data.detalle.length === 0 ? (
                    <div></div>
                ) : (
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Documento</th>
                                <th>Comentarios</th>
                                <th>Fecha Entrega</th>
                                <th>Descargar</th>
                                <th colSpan={3}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.detalle !== undefined &&
                                data.detalle !== null &&
                                data.detalle.length > 0 &&
                                data.detalle.map((item) => (
                                    <tr>
                                        <td
                                            className={
                                                item.enviar_revision ? "color-green" : "color-yellow"
                                            }
                                        >
                                            <ArticleIcon />
                                        </td>
                                        <td>{capitalizar(item.documento)}</td>
                                        <td>{item.comentarios}</td>
                                        <td>
                                            {item.habilitar === true &&
                                                item.enviar_revision &&
                                                item.tiene_documentacion === false && (
                                                    <div>{item.fecha_compromiso}</div>
                                                )}
                                        </td>
                                        <td>
                                            {item.tiene_documentacion === true && (
                                                <div
                                                    onClick={() => onImprimirArchivo(item.iddocumento)}
                                                >
                                                    <CloudDownloadIcon />
                                                    Descargar
                                                </div>
                                            )}
                                        </td>
                                        {item.estatus !== 'A' && item.estatus !== 'X' && data.estado.habilitar === true ? (
                                            <>
                                                <td>
                                                    <div
                                                        onClick={() => {
                                                            onModalComentarios("A", item.iddocumento)
                                                        }}
                                                    >
                                                        <CheckCircleIcon />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        onClick={() => {
                                                            onModalComentarios("M", item.iddocumento)
                                                        }}
                                                    >
                                                        <WarningIcon />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        title="Este documento no se pide en esta solicitud"
                                                        onClick={() => {
                                                            onModalComentarios("X", item.iddocumento)
                                                        }}
                                                    >
                                                        <BlockIcon />
                                                    </div>
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </>
                                        )}

                                    </tr>
                                ))}
                            {/* {data.documentacion.map((doc) => (
                <tr>
                  <td>{doc.documento}</td>
                  <td>
                    {doc.tiene_documentacion === true ? (
                      <div onClick={() => onImprimirArchivo(doc.iddocumento)}>
                        <CloudDownloadIcon />
                      </div>
                    ) : doc.iddocumento === 10 ? (
                      <div onClick={() => onImprimirPagare()}>
                        <CloudDownloadIcon />
                      </div>
                    ) : doc.iddocumento === 25 ? (
                      <div onClick={() => onImprimirPedidoMaquinaria()}>
                        <CloudDownloadIcon />
                      </div>
                    ) : (
                      <></>
                    )}
                  </td>
                  {doc.habilitar === false ? (
                    <td className="analianalisis-solicitud-credito-procesos-comentarios">
                      <OnGetIcon icon={doc.icono} />
                      {doc.comentarios}
                    </td>
                  ) : (
                    <td className="update-documento-analisis">
                      <div
                        onClick={() =>
                          openModal(doc.documento, doc.iddocumento)
                        }
                      >
                        <CloudUploadIcon />
                        Cargar
                      </div>
                    </td>
                  )}
                </tr>
              ))} */}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
